'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../_virtual/index.cjs');

/**
 * SVG Illustration of pestle mortar
 */ const PestleMortar = ({ assetColor = index.cjsExports.ASSET_COLORS.grey, size = index.cjsExports.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsxs("g", {
                clipPath: "url(#clip0_3427_23614)",
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M84.7734 49.9697H84.7649C84.6815 48.9306 83.8436 48.1074 82.8297 48.1074H24.6819C23.6673 48.1074 22.8294 48.9313 22.7467 49.9697H22.7383C22.7383 50.0167 22.7397 50.063 22.7397 50.1093C22.7397 50.1191 22.7383 50.1289 22.7383 50.1387V51.4934C22.7383 51.6911 22.767 51.8819 22.8182 52.0635C23.6814 63.555 31.5892 73.2116 42.496 77.2189C37.3592 78.57 33.9956 80.8194 33.9956 83.3668H73.5167C73.5167 80.8194 70.1532 78.57 65.0163 77.2189C75.9231 73.2116 83.831 63.555 84.6941 52.0635C84.7453 51.8826 84.7741 51.6911 84.7741 51.4934V50.1387C84.7741 50.1289 84.7727 50.1191 84.7727 50.1093C84.7727 50.0623 84.7741 50.016 84.7741 49.9697H84.7734Z",
                        fill: theme.ds5.asset[assetColor]["100"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M28.4047 37.7138L30.5005 48.1052H47.2004L38.6314 33.3412C39.0381 32.3638 39.2638 31.2875 39.2638 30.1579C39.2638 25.6697 35.7103 22.0312 31.3272 22.0312C26.9442 22.0312 23.3906 25.6697 23.3906 30.1586C23.3906 33.5901 25.4682 36.5225 28.4047 37.7145V37.7138Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    })
                ]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("defs", {
                children: /*#__PURE__*/ jsxRuntime.jsx("clipPath", {
                    id: "clip0_3427_23614",
                    children: /*#__PURE__*/ jsxRuntime.jsx("rect", {
                        width: "62.0351",
                        height: "61.3333",
                        fill: "white",
                        transform: "translate(22.7383 22.0312)"
                    })
                })
            })
        ]
    });
};

exports.PestleMortar = PestleMortar;
//# sourceMappingURL=PestleMortar.cjs.map
